export const queryKeys = {
  itemHistory: {
    productPrice: (id: string) =>
      ["item-history", "product-price", id] as const,
    productCost: (id: string) => ["item-history", "product-cost", id] as const,
    rawMaterialCost: (id: string) =>
      ["item-history", "raw-material-cost", id] as const,
  },
  workspaces: {
    all: ["workspaces"] as const,
    list: (params?: Record<string, unknown>) =>
      ["workspaces", "list", params] as const,
    branding: () => ["workspaces", "branding"] as const,
    bonusRules: (id: string) => ["workspaces", id, "bonus-rules"] as const,
    notificationSchedule: (id: string, type: string) =>
      ["workspaces", id, "notification-schedules", type] as const,
  },
  notificationChannels: {
    all: ["notification-channels"] as const,
    list: (params?: Record<string, unknown>) =>
      ["notification-channels", "list", params] as const,
  },
  emailConnections: {
    all: ["email-connections"] as const,
  },
  resendConnections: {
    all: ["resend-connections"] as const,
  },
  products: {
    all: ["products"] as const,
    list: (params?: Record<string, unknown>) =>
      ["products", "list", params] as const,
  },
  rawMaterials: {
    all: ["raw-materials"] as const,
    list: (params?: Record<string, unknown>) =>
      ["raw-materials", "list", params] as const,
    detail: (id: string) => ["raw-materials", "detail", id] as const,
  },
  riders: {
    all: ["riders"] as const,
    list: (params?: Record<string, unknown>) =>
      ["riders", "list", params] as const,
  },
  riderPayrolls: {
    all: ["rider-payrolls"] as const,
    list: (params?: Record<string, unknown>) =>
      ["rider-payrolls", "list", params] as const,
  },
  sales: {
    all: ["sales"] as const,
    list: (params?: Record<string, unknown>) =>
      ["sales", "list", params] as const,
  },
  receivables: {
    all: ["receivables"] as const,
    list: (params?: Record<string, unknown>) =>
      ["receivables", "list", params] as const,
  },
  expenses: {
    all: ["expenses"] as const,
    list: (params?: Record<string, unknown>) =>
      ["expenses", "list", params] as const,
    detail: (id: string) => ["expenses", "detail", id] as const,
  },
  cashReport: {
    get: (params?: Record<string, unknown>) => ["cash-report", params] as const,
  },
  grossProfitReport: {
    get: (params?: Record<string, unknown>) =>
      ["gross-profit-report", params] as const,
  },
  riderSales: {
    all: ["rider-sales"] as const,
    list: (params?: Record<string, unknown>) =>
      ["rider-sales", "list", params] as const,
    pendingPaymentSummary: ["rider-sales", "pending-payment-summary"] as const,
  },
  uoms: {
    all: ["uoms"] as const,
    list: (params?: Record<string, unknown>) =>
      ["uoms", "list", params] as const,
    usage: (id: string) => ["uoms", "usage", id] as const,
  },
  unitConversions: {
    all: ["unitConversions"] as const,
    list: (params?: Record<string, unknown>) =>
      ["unitConversions", "list", params] as const,
  },
  roles: {
    all: ["roles"] as const,
    list: (params?: Record<string, unknown>) =>
      ["roles", "list", params] as const,
    detail: (id: string) => ["roles", "detail", id] as const,
  },
  users: {
    all: ["users"] as const,
    list: (params?: Record<string, unknown>) =>
      ["users", "list", params] as const,
  },
  whatsapp: {
    devices: () => ["whatsapp", "devices"] as const,
  },
  whatsappLogin: {
    status: (id: string) => ["whatsapp-login", "status", id] as const,
  },
  numberSequences: {
    all: ["number-sequences"] as const,
    list: (workspaceId?: string) =>
      ["number-sequences", "list", workspaceId ?? ""] as const,
    detail: (entityType: string, workspaceId?: string) =>
      ["number-sequences", entityType, workspaceId ?? ""] as const,
  },
  stocks: {
    all: ["stocks"] as const,
    list: (params?: Record<string, unknown>) =>
      ["stocks", "list", params] as const,
    metrics: (workspaceId?: string) =>
      ["stocks", "metrics", workspaceId ?? ""] as const,
    card: (
      itemType: string,
      itemId: string,
      params?: Record<string, unknown>,
    ) => ["stocks", "card", itemType, itemId, params] as const,
    reasons: (params?: Record<string, unknown>) =>
      ["stocks", "reasons", params] as const,
    riders: (workspaceId?: string) =>
      ["stocks", "riders", workspaceId ?? ""] as const,
  },
  stockOpnames: {
    all: ["stock-opnames"] as const,
    list: (params?: Record<string, unknown>) =>
      ["stock-opnames", "list", params] as const,
    detail: (id: string) => ["stock-opnames", "detail", id] as const,
  },
  stockAdjustments: {
    all: ["stock-adjustments"] as const,
    list: (params?: Record<string, unknown>) =>
      ["stock-adjustments", "list", params] as const,
    detail: (id: string) => ["stock-adjustments", "detail", id] as const,
  },
  stockTransformations: {
    all: ["stock-transformations"] as const,
    list: (params?: Record<string, unknown>) =>
      ["stock-transformations", "list", params] as const,
    repackShrinkage: (params?: Record<string, unknown>) =>
      ["stock-transformations", "repack-shrinkage", params] as const,
  },
  openingStocks: {
    all: ["opening-stocks"] as const,
    list: (params?: Record<string, unknown>) =>
      ["opening-stocks", "list", params] as const,
    detail: (id: string) => ["opening-stocks", "detail", id] as const,
  },
  activityLogs: {
    all: ["activity-logs"] as const,
    list: (params?: Record<string, unknown>) =>
      ["activity-logs", "list", params] as const,
    entity: (
      entityName: string,
      entityId?: string | null,
      params?: Record<string, unknown>,
    ) => ["activity-logs", "entity", entityName, entityId, params] as const,
  },
} as const;
